export default __webpack_public_path__ + "static/media/vuesax-linear-book2.bbf92f09.svg";